export const ON = 'on';
export const OFF = 'off';
export const INPUT_TYPE_NUMBER = 'number';
